import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PlanList from "../PlanList";

/**
 * The sizes under one tile, as their own page.
 *
 * The catalogue collapses the sizes one plan was saved with into a single row, which is the right
 * thing to scan but the wrong thing to read a price or a sold count off - those belong to a size.
 * So the tile opens here, and here they are rows again.
 *
 * The route param is named productID because the key used to be the product, which pooled every
 * campaign selling one drink - three offers on Cappuccino opened as a single page of seven sizes.
 * It is the group's own id now; the dashboard only ever passes back what the listing row gave it,
 * so the name outlived the meaning and nothing here reads the value.
 *
 * Deliberately the same table rather than one of its own: the columns, the sorting, the status
 * picker and the edit form are all things a size should behave exactly as it did before it was
 * folded away. PlanList takes that key and lists the tile's sizes instead of the catalogue;
 * nothing else about it changes.
 */
const PlanGroupList = () => {
  const navigate = useNavigate();
  const { productID } = useParams();

  return (
    <div>
      <button
        className="pro-btn pro-btn-link pro-p-0 pro-mb-3"
        onClick={() => navigate("/user/subscription-plans")}
      >
        <span className="material-symbols-outlined">arrow_back</span>
        <span>Back to Subscription Plans</span>
      </button>

      <PlanList groupProductId={productID} title={"Sizes"} />
    </div>
  );
};

export default PlanGroupList;
